import { createAction } from "@reduxjs/toolkit";
import type { FundingRequestEligibilityVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveFundingRequestEligibility = createApiThunk<FundingRequestEligibilityVM, void>(
  "fundingRequests/retrieveFundingRequestEligibility",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.fundingRequestEligibility();
  },
);

export const resetRetrieveFundingRequestEligibility = createAction("fundingRequests/resetRetrieveFundingRequestEligibility");
